import { useEffect, useRef } from "preact/compat";

// storing a previous version of a prop for comparison
// similar to the old previousProps param from `componentDidUpdate`
const usePrevious = value => {
  const ref = useRef(null);
  useEffect(() => {
    ref.current = value;
  });
  return ref.current;
};
export default usePrevious;